import {SessionService} from "../services/session";
import {Link, LinkList} from "../directives/navigation/link";

export function linkFilter() {

  return function(items: LinkList, session: SessionService) {

    return items.filter((item) => {

      if (item.label == "LANDING.BECOME_HOST") {
        return !session.isLogged() || (session.isGuest() && !session.isHostRequested());
      }

      if (item.label == "LANDING.CREATE_DINNER") {
        return session.isHost();
      }

      return true;
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/filters/link.ts
 **/